function seededRandom(seed: number) {
  let s = seed
  return () => {
    s = (s + 0x6d2b79f5) | 0
    let t = Math.imul(s ^ (s >>> 15), 1 | s)
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296
  }
}

/** Seed that changes once per hour — same on SSR and client within the same hour. */
export function hourSeed(): number {
  return Math.floor(Date.now() / 3_600_000)
}

/** Fisher-Yates shuffle driven by a seeded PRNG. Returns a new array. */
export function seededShuffle<T>(array: T[], seed: number): T[] {
  const rand = seededRandom(seed)
  const result = [...array]
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(rand() * (i + 1))
    ;[result[i], result[j]] = [result[j], result[i]]
  }
  return result
}
